// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Vloa","icon":"styles_icon__2VlV_"};